import React, { useMemo, useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import moment from "moment-jalaali";
import cloneDeep from "lodash/cloneDeep";
import { onSearchByText2 } from "utils/groupUtils";
// import { marginInlineStart, colors } from "utils/theme";
import SelectComponent from "../../../SelectComponent";
import DateComponent from "../../../DateComponent";
import TextFieldComponent from "../../../TextFieldComponent";
import Button from "../../../Button";

import {
  getOrientations,
  getSegments,
  flatPlanningList,
  getTerms,
  getProfessors,
} from "../../../utils";

const initQueries = {
  courseTitle: "",
  examDate: "",
  orientation: "-1",
  segment: "-1",
};

function CoursesFilterFormCMP({ className, setFormatted, coursesData }) {
  const orientations = useMemo(
    () => [
      {
        label: "همه",
        value: "-1",
      },
      ...getOrientations(coursesData).map((item) => ({
        ...item,
        label: item.name,
      })),
    ],
    [coursesData]
  );
  const segments = useMemo(
    () => [
      {
        label: "همه",
        value: "-1",
      },
      ...getSegments(coursesData).map((item) => ({
        ...item,
        label: item.name,
      })),
    ],
    [coursesData]
  );
  const terms = useMemo(
    () => [
      {
        label: "همه",
        value: "-1",
      },
      ...getTerms(coursesData).map((item) => ({ ...item, label: item.name })),
    ],
    [coursesData]
  );
  const professors = useMemo(
    () => [
      {
        label: "همه",
        value: "-1",
      },
      ...getProfessors(coursesData).map((item) => ({
        ...item,
        label: item.name,
      })),
    ],
    [coursesData]
  );

  // Form Init
  const methods = useForm();
  const {
    handleSubmit,
    reset,
    formState: { errors },
  } = methods;

  const resetForm = () => {
    reset(initQueries);
    setFormatted([...coursesData]);
    setSelectedDate([]);
  };
  useEffect(() => {
    reset(initQueries);
    setFormatted([...coursesData]);
    setSelectedDate([]);
  }, [coursesData]);
  const [selectedDate, setSelectedDate] = useState([]);

  const onSubmit = async (queries) => {
    try {
      let dataToSet = cloneDeep(coursesData);
      const flattenCoursesData = flatPlanningList(coursesData);
      // Course Title Search
      if (queries?.courseTitle?.length > 0) {
        const tempCourses = cloneDeep(coursesData).map((item) =>
          cloneDeep(item).map((v) => ({
            ...v,
            planningList: v.planningList
              ? v.planningList.map((vp) => ({ ...vp, courses: [] }))
              : [], // Reset Planning list of Courses to just add search results
          }))
        );
        // const titleSearchResultTemp = await onSearchByText(
        //   queries.courseTitle,
        //   ['title'],
        //   flattenCoursesData
        // );
        const titleSearchResultTemp = await onSearchByText2(
          queries.courseTitle,
          coursesData
        );

        // titleSearchResultTemp.forEach((v) => {
        //   const { courseIndex, planningIndex, termIndex } = v.meta.position; // Position of Occurance

        //   tempCourses[courseIndex].planningList[planningIndex].courses.push(
        //     cloneDeep(
        //       coursesData[courseIndex].planningList[planningIndex].courses[
        //         termIndex
        //       ]
        //     )
        //   ); // Push the found Course
        // });

        dataToSet = cloneDeep(titleSearchResultTemp);
      }
      // Orientation Filter
      if (
        queries?.orientation?.value &&
        // eslint-disable-next-line eqeqeq
        queries?.orientation?.value != -1 &&
        `${queries?.orientation?.value ?? ""}`.length > 0
      ) {
        const res = dataToSet.map((item) =>
          item.filter(
            (oriItem) => oriItem?.title === queries?.orientation?.value
          )
        );
        dataToSet = cloneDeep(res);
      }

      // Segment Filter

      if (
        queries?.segment?.value &&
        // eslint-disable-next-line eqeqeq
        queries?.segment?.value != -1 &&
        `${queries?.segment?.value ?? ""}`.length > 0
      ) {
        const res = dataToSet?.map((item) =>
          item.filter(
            (oriItem) =>
              oriItem?.segmentAndSegmentType === queries?.segment?.value
          )
        );
        dataToSet = cloneDeep(res);
      }

      // Term Filter
      if (
        queries?.term &&
        `${queries.term?.value ?? ""}`.length > 0 &&
        `${queries.term?.value ?? ""}` !== "-1"
      ) {
        const res = [];
        const tempCourses = cloneDeep(dataToSet);

        tempCourses.forEach((item, i) => {
          const cloned = cloneDeep(item);
          cloned?.forEach((course) => {
            if (!course.planningList) return;
            const tempCourse = { ...cloneDeep(course), planningList: [] };
            tempCourse.planningList = course.planningList.filter(
              (plngItem) => plngItem?.title === queries?.term?.value
            );
            if (tempCourse.planningList.length > 0) {
              if (Array.isArray(res[i])) {
                res[i].push(tempCourse);
              } else {
                res[i] = [tempCourse];
              }
            }
          });
        });
        dataToSet = cloneDeep(res);
      }

      // Prof Filter
      if (
        queries?.professor?.value &&
        `${queries?.professor?.value ?? ""}`.length > 0 &&
        `${queries?.professor?.value ?? ""}` !== "-1"
      ) {
        const res = [];
        const tempCourses = cloneDeep(dataToSet);
        tempCourses?.forEach((item, i) => {
          const cloned = cloneDeep(item);
          cloned?.forEach?.((course) => {
            if (!course.planningList) return;
            const tempCourse = { ...cloneDeep(course), planningList: [] };

            course.planningList?.forEach((plng) => {
              const tempPlng = { ...plng, courses: [] };
              tempPlng.courses = plng.courses.filter(
                (crs) => crs.professor === queries?.professor?.value
              );
              if (tempPlng.courses.length > 0) {
                tempCourse.planningList.push(tempPlng);
              }
            });

            if (tempCourse.planningList.length > 0) {
              if (Array.isArray(res[i])) {
                res[i].push(tempCourse);
              } else {
                res[i] = [tempCourse];
              }
            }
          });
        });

        dataToSet = cloneDeep(res);
      }

      // Exam Date (Range) Filter
      const [fromDate, toDate] = selectedDate || [undefined, undefined];

      if (fromDate) {
        const fromMoment = moment(
          `${fromDate.year}/${fromDate.month}/${fromDate.day}`,
          "jYYYY/jM/jD"
        );

        const res = [];
        const tempCourses = cloneDeep(dataToSet);
        tempCourses?.forEach((item) => {
          const cloned = cloneDeep(item);
          cloned?.forEach((course) => {
            if (!course.planningList) return;
            const tempCourse = { ...cloneDeep(course), planningList: [] };

            course.planningList?.forEach((plng) => {
              const tempPlng = { ...plng, courses: [] };

              tempPlng.courses = plng.courses.filter(
                (crs) =>
                  crs.examDate &&
                  `${crs.examDate}`.length > 0 &&
                  moment(new Date(crs.examDate)).diff(fromMoment, "days") >= 0
              );

              if (tempPlng.courses.length > 0) {
                tempCourse.planningList.push(tempPlng);
              }
            });

            if (tempCourse.planningList.length > 0) {
              res.push(tempCourse);
            }
          });
        });
        dataToSet = cloneDeep(res);
      }

      if (toDate) {
        const toMoment = moment(
          `${toDate.year}/${toDate.month}/${toDate.day}`,
          "jYYYY/jM/jD"
        );

        const res = [];
        const tempCourses = cloneDeep(dataToSet);
        tempCourses?.forEach((item) => {
          const cloned = cloneDeep(item);
          cloned?.forEach((course) => {
            if (!course.planningList) return;
            const tempCourse = { ...cloneDeep(course), planningList: [] };

            course.planningList?.forEach((plng) => {
              const tempPlng = { ...plng, courses: [] };

              tempPlng.courses = plng.courses.filter(
                (crs) =>
                  crs.examDate &&
                  `${crs.examDate}`.length > 0 &&
                  toMoment.diff(moment(new Date(crs.examDate)), "days") >= 0
              );
              if (tempPlng.courses.length > 0) {
                tempCourse.planningList.push(tempPlng);
              }
            });

            if (tempCourse.planningList.length > 0) {
              if (Array.isArray(res[i])) {
                res[i].push(tempCourse);
              } else {
                res[i] = [tempCourse];
              }
            }
          });
        });

        dataToSet = cloneDeep(res);
      }

      setFormatted([...dataToSet]);
    } catch (error) {
      console.log(`error`, error);
    }
  };

  return (
    <FormProvider {...methods}>
      <div className={className}>
        <form className="__header-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-x-[30px] md:tw-gap-x-10 tw-gap-y-[26px]">
            <div className="tw-col-span-2 md:tw-col-span-3">
              <TextFieldComponent name="courseTitle" label="عنوان درس" />
            </div>
            <div className="tw-col-span-2 md:tw-col-span-1">
              <SelectComponent
                name="orientation"
                label="رشته / گرایش"
                placeholder="همه"
                options={orientations}
              />
            </div>
            <div>
              <SelectComponent
                name="segment"
                label="مقطع"
                placeholder="همه"
                options={segments}
              />
            </div>
            <div>
              <SelectComponent
                name="term"
                label="ترم تحصیلی"
                placeholder="همه"
                options={terms}
              />
            </div>
            <div>
              <SelectComponent
                name="professor"
                label="استاد درس"
                placeholder="همه"
                options={professors}
              />
            </div>
            <div>
              <DateComponent
                value={selectedDate}
                onChange={setSelectedDate}
                name="examDate"
                label="تاریخ آزمون"
                placeholder="انتخاب بازه تاریخ"
              />
            </div>
            <div className="tw-col-span-2 sm:tw-col-span-1">
              <Button onClick={resetForm} layout="secondary" type="button">
                حذف فیلتر ها
              </Button>
            </div>
            <div className="tw-col-span-2 sm:tw-col-span-1">
              <Button type="submit" layout="primary">
                جستجو
              </Button>
            </div>
          </div>
        </form>
      </div>
    </FormProvider>
  );
}

export default CoursesFilterFormCMP;
